import React, { useState } from 'react'
import styled from '@emotion/styled'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { colors, styles } from 'Constants'

import { Flex, Grid, Base } from 'lese'

import Header from 'Components/Header'
import Button from 'Components/Button'

const Card = styled(Flex)`
  border: 2px solid ${colors.borderColor};
  border-radius: ${styles.borderRadius};
  padding: 32px;

  ${({ disabled }) =>
    disabled &&
    `
  opacity: 0.4;
  pointer-events: none;
  `}
`

const Title = Header.withComponent('h3')

export default ({
  title,
  onClick,
  href,
  icon,
  subtitle,
  buttonText,
  useButton,
  color,
  children,
  ...props
}) => {
  return (
    <Card column separation="32px" {...props}>
      <Flex xAlign="space-between">
        <Flex column>
          <Base fontSize="0.8em">{subtitle || 'Sort by'}</Base>
          <Title size="1.7">{title}</Title>
        </Flex>
        <FontAwesomeIcon
          icon={icon}
          size="2x"
          color={color || colors.secondary}
        />
      </Flex>
      {children}
      {(useButton === undefined || useButton) && (
        <Button color={color} onClick={onClick} href={href}>
          {buttonText || 'Start'}
        </Button>
      )}
    </Card>
  )
}
